import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PriceFormat from './PriceFormat';
import PriceFormatEur from './PriceFormatEUR';
import { FormattedMessage } from 'react-intl';

class PriceLocalised extends Component {
    render() {
        const { value, currency } = this.props;
        if (value === null || value === undefined) {
            return null;
        }

        if (value === 0) {
            return (
                <span>
                    <FormattedMessage defaultMessage="zdarma" id={'global.free'} />
                </span>
            );
        }

        if (currency === 'EUR') {
            return (
                <PriceFormatEur
                    value={value}
                    minimumFractionDigits={this.props.minimumFractionDigits}
                />
            );
        } else {
            return (
                <PriceFormat
                    value={value}
                    minimumFractionDigits={this.props.minimumFractionDigits}
                />
            );
        }
    }
}

PriceLocalised.propTypes = {
    value: PropTypes.number.isRequired,
    minimumFractionDigits: PropTypes.number
};

function mapStateToProps(state) {
    return {
        currency: state.pageSettings.currency
    };
}

export default connect(
    mapStateToProps,
    {}
)(PriceLocalised);
